<template>
    <div>
        <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

        <div v-if="(!errors && !loading && (total_items == 0))" class="alert alert-warning" role="alert">
            {{ $root.text(
                'There are no {resource} types that match your selection',
                { resource: $root.text($root.contents.asset_title, null, false, 'asset_title') },
                true
            ) }}
        </div>
        <div v-if="(total_items > 0)" class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-sm-1 col-2">{{ $root.text('Sort', null, true) }}</div>
                                        <div class="col">{{ $root.text('Name', null, true) }}</div>
                                        <div class="col-1">&nbsp;</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <draggable
                            v-model="items"
                            ghost-class="vue-drag-ghost"
                            handle=".drag-handle"
                            tag="tbody"
                            @end="onDragSortEnd"
                            animation="200"
                        >
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row" :id="'asset_type-row' + item.id" class="pb-0">
                                    <div class="row">
                                        <div class="col-sm-1 col-2 font-size-18 contact-links">
                                            <a
                                                href="#"
                                                class="drag-handle"
                                                style="cursor: move"
                                                v-b-tooltip.hover
                                                :title="$root.text('Re-order', null, true)"
                                                @click.prevent="doNothing()"
                                            >
                                                <i class="fas fa-arrow-down-arrow-up"></i>
                                            </a>
                                        </div>
                                        <div class="col" style="padding-top: 3px">
                                            <h5 class="font-size-14 mb-0">
                                                <a href="#" class="text-dark" @click.prevent="toggleEditAssetType(item)">
                                                    {{ item.name }}
                                                </a>
                                            </h5>
                                        </div>
                                        <div class="col-1 font-size-18 contact-links">
                                            <a
                                                href="#"
                                                class="float-right"
                                                @click.prevent="toggleEditAssetType(item)"
                                            >
                                                <span
                                                    v-if="(asset_type_details_open.indexOf(item.id) < 0)"
                                                    :key="'close-' + item.id"
                                                >
                                                    <i class="fa-regular fa-chevron-circle-down"></i>
                                                </span>
                                                <span v-else :key="'open-' + item.id">
                                                    <i class="fa-regular fa-chevron-circle-up"></i>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row list-details-td mt-2">
                                        <div class="col-12 list-details" :id="'asset_type-details' + item.id">
                                            <asset-type-edit-form
                                                :data="item"
                                                :list_component="thisComponent()"
                                            ></asset-type-edit-form>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                </div>
            </div>
        </div>

        <div style="position: relative; top: -20px; height: 40px; overflow: visible">
            <loading v-if="loading"></loading>
        </div>

        <div
            class="modal fade"
            id="asset-type-delete-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="asset-type-delete-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <asset-type-delete></asset-type-delete>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import debounce from 'lodash/debounce';
    export default {
        components: {
            draggable,
        },
        data () {
            return {
                component_name: 'asset-types',
                loading: false,
                errors: false,
                items: [],
                total_items: 0,
                current_page: 1,
                last_page: 1,
                asset_type_details_open: []
            }
        },
        created() {
            this.handleDebouncedScroll = debounce(this.handleScroll, 100);
            window.addEventListener('scroll', this.handleDebouncedScroll);
        },
        mounted () {
            $('body').removeClass('login-body');
            this.getAssetTypes();
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleDebouncedScroll);
        },
        methods: {
            thisComponent: function () {
                return this;
            },
            handleScroll(event) {
                if ((this.current_page < this.last_page) && !this.loading) {
                    const pageScrollTop = $('html, body').scrollTop();
                    const appHeight = $('#app').outerHeight();
                    const windowHeight = $(window).height();
                    const scrollPosition = appHeight - (pageScrollTop + windowHeight);
                    if (scrollPosition < 200) {
                        this.getAssetTypes(this.current_page + 1);
                    }
                }
            },
            getAssetTypes: function (page = 1) {
                if (!this.$root.hasPermission('assets_asset_types')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                if (this.loading || (page < 1) || ((page > 1) && (page <= this.current_page))) {
                    return false;
                }
                this.current_page = page;
                this.loading = true;
                this.errors = false;

                if (page == 1) {
                    this.items = [];
                    this.total_items = 0;
                    this.current_page = 1;
                    this.last_page = 1;
                    this.asset_type_details_open = [];
                }

                /**
                 * Send request to API
                 */
                const url = this.$root.$data.app.api_url + '/' + this.$root.$data.app.client_id
                    + '/resource-types/active?page=' + page;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.$data.token }
                })
                .then(response => {
                    vm.total_items = response.data.resource_types.total;
                    vm.current_page = response.data.resource_types.current_page;
                    vm.last_page = response.data.resource_types.last_page;
                    response.data.resource_types.data.forEach((item, index) => {
                        delete item.sort_order;
                        vm.items.push(item);
                    });
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            toggleEditAssetType: function (asset_type) {
                if (this.asset_type_details_open.indexOf(asset_type.id) < 0) {
                    this.asset_type_details_open.push(asset_type.id);
                    $('#asset_type-row' + asset_type.id).addClass('highlighted');
                    $('#asset_type-details' + asset_type.id).slideDown('slow');
                } else {
                    var vm = this;
                    $('#asset_type-details' + asset_type.id).slideUp('slow', function () {
                        $('#asset_type-row' + asset_type.id).removeClass('highlighted');
                        for (var n = 0; n < vm.asset_type_details_open.length; n++) { 
                            if (vm.asset_type_details_open[n] == asset_type.id) { 
                                vm.asset_type_details_open.splice(n, 1); 
                            }
                        }
                    });
                }
            },
            onDragSortEnd: function(event) {
                if (event.newIndex == event.oldIndex) {
                    return false;
                }
                this.errors = false;
                /**
                 * Send move asset type request to API
                 */
                const url = this.$root.$data.app.api_url + '/' + this.$root.$data.app.client_id + '/resource-type/'
                    + this.items[event.newIndex].id + '/move';
                const data = {
                    sort_order: event.newIndex
                };
                var vm = this;

                axios({
                    method: 'put',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.$data.token }
                })
                .then(response => {
                    // do nothing?
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                });
            },
            doNothing: function () {
                return null;
            }
        }
    }
</script>
